import AccountVerificationFormStep1 from 'features/customerPanel/accountVerification/component/verificationSteps/accountVerificationFormStep1';
import AccountVerificationFormStep2 from 'features/customerPanel/accountVerification/component/verificationSteps/accountVerificationFormStep2';
import AccountVerificationFormStep3 from 'features/customerPanel/accountVerification/component/verificationSteps/accountVerificationFormStep3';
import AccountVerificationFormStep4 from 'features/customerPanel/accountVerification/component/verificationSteps/accountVerificationFormStep4';
import AccountVerificationFormStep5 from 'features/customerPanel/accountVerification/component/verificationSteps/accountVerificationFormStep5';
import AccountVerificationFormStep6 from 'features/customerPanel/accountVerification/component/verificationSteps/accountVerificationFormStep6';

export const verificationFormSteps = [
	AccountVerificationFormStep1,
	AccountVerificationFormStep2,
	AccountVerificationFormStep3,
	AccountVerificationFormStep4,
	AccountVerificationFormStep5,
	AccountVerificationFormStep6,
];
